import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { uploadRegionsRoute } from '~/paths';

export default function UploadRegionBreadcrumbWrapper() {
  // Wrapper component for generating a breadcrumb entry
  useBreadcrumb('routes/upload/model/region', 'Regions', uploadRegionsRoute());
  return <Outlet />;
}
